import { render, staticRenderFns } from "./ComponentOverview.vue?vue&type=template&id=ad228aea&scoped=true"
import script from "./ComponentOverview.vue?vue&type=script&lang=js"
export * from "./ComponentOverview.vue?vue&type=script&lang=js"
import style0 from "./ComponentOverview.vue?vue&type=style&index=0&id=ad228aea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad228aea",
  null
  
)

export default component.exports